import { generatedBuilderThemePresetCatalog } from './preset-catalog.generated';
import type {
  BuilderPageType,
  BuilderThemePreset,
  BuilderThemePresetId,
  BuilderThemeStarterPageTemplate,
  BuilderThemeTokens
} from '@shared/types';

export const builderThemePresetCatalog: BuilderThemePreset[] = generatedBuilderThemePresetCatalog.map((preset) => ({
  ...preset
})) as BuilderThemePreset[];

export function isBuilderThemePresetId(value: string | null | undefined): value is BuilderThemePresetId {
  return builderThemePresetCatalog.some((preset) => preset.id === value);
}

export function normalizeBuilderThemePresetId(
  value: string | null | undefined,
  fallback: BuilderThemePresetId = 'corporate_services'
): BuilderThemePresetId {
  return isBuilderThemePresetId(value) ? value : fallback;
}

export function getBuilderThemePreset(
  value: string | null | undefined,
  fallback: BuilderThemePresetId = 'corporate_services'
): BuilderThemePreset {
  const normalizedId = normalizeBuilderThemePresetId(value, fallback);
  return (
    builderThemePresetCatalog.find((preset) => preset.id === normalizedId) ??
    builderThemePresetCatalog.find((preset) => preset.id === fallback) ??
    builderThemePresetCatalog[0]
  ) as BuilderThemePreset;
}

export function getBuilderThemeStarterPageTemplate(
  presetId: string | null | undefined,
  pageType: BuilderPageType
): BuilderThemeStarterPageTemplate | null {
  const preset = getBuilderThemePreset(presetId);
  return preset.starterPages[pageType] ?? null;
}

export function getBuilderThemeCssVariables(tokens: BuilderThemeTokens): Record<string, string> {
  return {
    '--av-accent': tokens.accent,
    '--av-accent-strong': tokens.accentStrong,
    '--av-surface': tokens.surface,
    '--av-surface-strong': tokens.surfaceStrong,
    '--av-surface-muted': tokens.surfaceMuted,
    '--av-text': tokens.text,
    '--av-muted': tokens.muted,
    '--av-copy': tokens.copy,
    '--av-border': tokens.border,
    '--av-highlight': tokens.highlight,
    '--av-hero-surface': tokens.heroSurface,
    '--av-hero-text': tokens.heroText,
    '--av-card-surface': tokens.cardSurface
  };
}
